import { createQueryKeys } from "@lukemorales/query-key-factory"

import axios from "@/api/axios"
import { APIFn } from "@/api/utils"

import {
  CurrentCourseAnalytics,
  DashboardMasterClassData,
  LearningDurationAnalytics,
  MasterclassAnalytics,
  OrganizationCourseAnalytics,
  TopLearnersByDuration,
} from "./types"

export const DashboardQueryKey = createQueryKeys("dashboard", {
  getMasterclassAnalytics: (props, orgId) => ({
    queryKey: ["get-masterclass-analytics", props, orgId],
  }),
  getDashboardMasterclassData: ({ orgId }: { orgId: string }) => ({
    queryKey: ["get-dashboard-masterclass-data", orgId],
  }),
  getCurrentCourseAnalytics: (props, orgId) => ({
    queryKey: ["get-current-course-analytics", props, orgId],
  }),
  getLearningDurationAnalytics: ({ orgId }: { orgId: string }) => ({
    queryKey: ["get-learning-duration-analytics", orgId],
  }),
  getTopLearnersByDurationAnalytics: ({ orgId }: { orgId: string }) => ({
    queryKey: ["get-top-learners-by-duration-analytics", orgId],
  }),
  getCourseAnalytics: ({ orgId }: { orgId: string }) => ({
    queryKey: ["get-course-analytics", orgId],
  }),
})

type Resource = {
  getMasterclassAnalytics: APIFn<MasterclassAnalytics, { orgId: string }>
  getDashboardMasterclassData: APIFn<
    DashboardMasterClassData[],
    { orgId: string }
  >
  getCurrentCourseAnalytics: APIFn<CurrentCourseAnalytics[], { orgId: string }>
  getLearningDurationAnalytics: APIFn<
    LearningDurationAnalytics,
    { orgId: string }
  >
  getTopLearnersByDurationAnalytics: APIFn<
    TopLearnersByDuration[],
    { orgId: string }
  >
  getCourseAnalytics: APIFn<OrganizationCourseAnalytics, { orgId: string }>
}

export const DashboardResource: Resource = {
  getMasterclassAnalytics: ({ urlParams, ...config }) =>
    axios.get(
      `/eris/v1/organizations/${urlParams.orgId}/masterclass-analytics/`,
      config,
    ),

  getDashboardMasterclassData: ({ urlParams, ...config }) =>
    axios.get(`/v1/organizations/${urlParams.orgId}/masterclasses/`, config),

  getCurrentCourseAnalytics: ({ urlParams, ...config }) =>
    axios.get(
      `/v1/organizations/${urlParams.orgId}/users/courses/analytics/`,
      config,
    ),

  getLearningDurationAnalytics: ({ urlParams, ...config }) =>
    axios.get(
      `/v1/organizations/${urlParams.orgId}/learning-duration/`,
      config,
    ),

  getTopLearnersByDurationAnalytics: ({ urlParams, ...config }) =>
    axios.get(
      `/v1/organizations/${urlParams.orgId}/top-learners-learning-duration/`,
      config,
    ),

  getCourseAnalytics: ({ urlParams, ...config }) =>
    axios.get(
      `/v1/organizations/${urlParams.orgId}/courses/analytics/`,
      config,
    ),
}
